  <p class="p-2">
    <span data-dismiss="modal" 
      aria-label="Close" 
      class="cursor-pointer float-right clearfix">
      <span aria-hidden="true" >
        <img (click)="goBack()" src="assets/themes/icons/cancel.svg" alt="close icon">
      </span>
    </span>
  </p>
  <div class="mt-5 mb-5">
    <p class="heading-4">
      <span class="color-grey-7000">{{mls?.languageText?.cme_desc?.key1}}<span *ngIf="mls?.is_lskey_display == 1">(cme_desc.key1)</span></span>
    </p>
    <p class="secondary-paragraph" innerHTML="{{data.data}}"> </p>
  </div>